import React, { FC, useState } from 'react';
import { View } from "react-native";
import { useSharedValue } from "react-native-reanimated";
import Carousel, {
    ICarouselInstance,
    Pagination,
} from "react-native-reanimated-carousel";
import styled from '@emotion/native';
import setTheme from '@lib/theme';

import { Spacer } from '@components/1-atoms';
import { PageProps } from '@lib/constants';

const Container = styled.View`
  align-self: center;
  justify-content: center;
  flex-direction: column;
  min-width: 100%;
  // width: ${({ mini, theme }: any) => mini ? `${theme.columnWidth - 2}px` : `${theme.contentWidth}px`};
`;



type Props = Omit<PageProps, 'data'> & {
    data: React.FC[];
};

const theme = setTheme('light');
const width = theme.contentWidth as number;

const Component: FC<Props> = ({ navigation, data, ...props }) => {

    const [height, setHeight] = useState(0);
    const ref = React.useRef<ICarouselInstance>(null);
    const progress = useSharedValue<number>(0);

    const onPressPagination = (index: number) => {
        ref.current?.scrollTo({
            count: index - progress.value,
            animated: true,
        });
    };

    const _renderItem = ({ item: Item }: { item: React.FC<Omit<Props, 'data'>> }) => (
        <View
            style={{
                flex: 1,
                justifyContent: "flex-end",
                alignItems: "flex-end",
            }}
        >
            <Item navigation={navigation} />
        </View>
    );

    return (
        <Container>
            <View pointerEvents="none" style={{ position: 'absolute', width: width, opacity: 0, zIndex: -100 }}>
                {data.map((Item, index) => (
                    <View key={index} onLayout={(e) => {
                        const { height: h } = e.nativeEvent.layout;
                        setHeight((prev) => Math.max(prev, h));
                    }}>
                        <Item />
                    </View>
                ))}
            </View>

            <Carousel
                ref={ref}
                style={{ width, height: height }}
                width={width}
                height={height}
                data={data}
                onProgressChange={progress}
                renderItem={_renderItem}
                mode="horizontal-stack"
                modeConfig={{
                    snapDirection: 'left',
                    rotateZDeg: 30,
                }}
                {...props}
            />

            <Pagination.Basic
                progress={progress}
                data={data}
                dotStyle={{ backgroundColor: "rgba(255, 255, 255, 0.6)", borderRadius: 50 }}
                activeDotStyle={{ backgroundColor: "rgba(255, 255, 255, 1)", borderRadius: 50 }}
                containerStyle={{ gap: 6, marginTop: 9 }}
                onPress={onPressPagination}
            />
            <Spacer h={1} />
        </Container>
    );
};

export default Component;